import type { RunLogEntry } from "./useCompetitorLinkRemovalDetail";

/**
 * Текстовое представление лога прогона: одна строка на запись, с ISO-меткой
 * времени впереди — тот же формат, что у экспорта лога задачи
 * (RegisterExportTaskLogEndpoint). Полная история лога приходит на подписку
 * (CLR-09) и дальше течёт живыми событиями, поэтому файл собирается из того,
 * что уже в памяти, без отдельной ручки бэкенда.
 */
export class RunLogExport {
  public static content(logs: RunLogEntry[]): string {
    const lines = logs.map((log) => `${new Date(log.createdAt).toISOString()} ${log.message}`);
    return lines.join("\n");
  }

  public static fileName(removalId: string): string {
    return `competitor-link-removal-${removalId}-log.txt`;
  }
}
